import React from 'react'
import ReactDOM from 'react-dom/client'
import { RootCmp } from './RootCmp'

import './assets/styles/main.scss'

ReactDOM.createRoot(document.getElementById('root')).render(
    <RootCmp />
)
